import { Box, Skeleton } from '@mui/material';
import { useDirectoryData } from '../Contexts/DirectoryContext';
import { useDirectoryFilters } from '../Contexts/DirectoryFiltersContext';
import { ReportsPagination } from '../ModerationAdmin/styles';

export const DIRECTORY_DEFAULT_NUM_PER_PAGE = 10;

const DirectoryPagination = () => {
  const { page, setPage } = useDirectoryFilters();
  const { filteredUsersCountQuery, numPerPage } = useDirectoryData();
  const { data: filteredUsersCount } = filteredUsersCountQuery;

  const count = Math.ceil(
    (filteredUsersCount?.count || 1) / (numPerPage || DIRECTORY_DEFAULT_NUM_PER_PAGE),
  );

  return (
    <Box display={'flex'} justifyContent={'center'}>
      <ReportsPagination
        count={count}
        page={page}
        size='small'
        onChange={(event, value) => {
          setPage(value);
        }}
      />
    </Box>
  );
};

export default DirectoryPagination;

export const DirectoryPaginationSkeleton = () => {
  return (
    <Box display={'flex'} justifyContent={'center'} mt={2}>
      <Box sx={{ width: '100%', maxWidth: 400, display: 'flex', justifyContent: 'center' }}>
        <Skeleton variant='circular' width={30} height={28} sx={{ mr: 8 }} />

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Skeleton variant='circular' width={24} height={24} sx={{ mx: 0.5 }} />
          <Skeleton variant='circular' width={24} height={24} sx={{ mx: 0.5 }} />
          <Skeleton variant='circular' width={24} height={24} sx={{ mx: 0.5 }} />
          <Skeleton variant='circular' width={24} height={24} sx={{ mx: 0.5 }} />
        </Box>

        <Skeleton variant='circular' width={30} height={28} sx={{ ml: 8 }} />
      </Box>
    </Box>
  );
};
